import classNames from "classnames";
import * as PropTypes from "prop-types";

import stackedSliderStyles from "./StackedSlider.css";

import {
  CustomCursorPlus,
  IconChevronLeft,
  IconChevronRight,
} from "/react/library/";

import { StackedSliderIndicator } from "./StackedSliderIndicator";
import { StackedSliderCaption } from "./StackedSliderCaption";

export class StackedSliderControls extends React.PureComponent {
  static propTypes = {
    activeSlide: PropTypes.node.isRequired,
    activeSlideIndex: PropTypes.number.isRequired,
    goToNextSlide: PropTypes.func.isRequired,
    goToPreviousSlide: PropTypes.func.isRequired,
    hasMultipleSlides: PropTypes.bool.isRequired,
    hasStackedLayout: PropTypes.bool.isRequired,
    originalTotalSlides: PropTypes.number.isRequired,
    toggleFullscreen: PropTypes.func.isRequired,
    hideOnMobile: PropTypes.bool,
  };

  render() {
    const {
      activeSlide,
      activeSlideIndex,
      goToNextSlide,
      goToPreviousSlide,
      hasMultipleSlides,
      hasStackedLayout,
      originalTotalSlides,
      toggleFullscreen,
      hideOnMobile,
    } = this.props;

    const stackedSliderIndicatorProps = {
      activeSlideIndex,
      originalTotalSlides,
    };

    const activeSlideCaption = activeSlide.props.caption || null;
    const activeSlideTitle = activeSlide.props.title || null;

    return (
      <div
        className={classNames(
          hideOnMobile
            ? stackedSliderStyles.controlsContainerHiddenMobile
            : stackedSliderStyles.controlsContainer,
          {
            [stackedSliderStyles.controlsContainerIsStacked]: hasMultipleSlides,
          }
        )}
      >
        {hasStackedLayout && <CustomCursorPlus onClick={toggleFullscreen} />}
        {activeSlideCaption && (
          <StackedSliderCaption
            hideOnMobile={hideOnMobile}
            caption={activeSlideCaption}
            title={activeSlideTitle}
          />
        )}
        {hasMultipleSlides && (
          <React.Fragment>
            <div className={stackedSliderStyles.controls}>
              <span
                className={classNames(
                  stackedSliderStyles.buttonWithIcon,
                  stackedSliderStyles.controlsButtonPrevious
                )}
                onClick={goToPreviousSlide}
              >
                <IconChevronLeft hasBox isLight />
              </span>
              <span
                className={classNames(
                  stackedSliderStyles.buttonWithIcon,
                  stackedSliderStyles.controlsButtonNext
                )}
                onClick={goToNextSlide}
              >
                <IconChevronRight hasBox isLight />
              </span>
            </div>
            <StackedSliderIndicator {...stackedSliderIndicatorProps} />
          </React.Fragment>
        )}
      </div>
    );
  }
}
